import { RegexEnum } from './../../../../core/enum/regex.enum';
import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import * as _ from 'lodash';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Observable, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';


@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateSupplierComponent implements OnInit, AfterViewInit {
  public supplierUserID: string;
  private sub: any;
  private redirectUrl;
  public userType: string = 'user';
  public viewOnly: boolean = false;
  public loading: boolean = false;
  public supplierUpdate: {} = { organizationCode: '' };
  public privileges: {} = {
    HC_SUPPLIER_CREATE_USER: false, HC_SUPPLIER_DELETE_USER: false,
    HC_SUPPLIER_UPDATE_USER: false, HC_SUPPLIER_VIEW_USER: false,
    HC_SUPPLIER_PURCHASE_ORDERS: false
  };
  public userManagement: boolean = false;
  public originLimitations: boolean = false;
  public destinationLimitations: boolean = false;
  public isAdhoc: boolean = false;
  public currentUserRole: string = '';
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public roleOptions: object[] = [];
  public supplierUserRole: {} = {
    value: 'HC_SUPPLIER_USER',
    name: 'Supplier User',
    description: 'A supplier user can access the supplier portal, view and maintain purchase orders. They cannot create or manage other users of the portal.'
  };
  public supplierAdminRole: {} = {
    value: 'HC_SUPPLIER_ADMIN',
    name: 'Supplier Admin',
    description: 'Supplier admins can access the entire supplier portal as well as create and manage users of their portal. They can also manage privileges and access.'
  };

  public regexEnum = RegexEnum;
  @ViewChild(RouterOutlet, { static: false }) outlet: RouterOutlet;

  constructor(
    public currentUserService: CurrentUserService,
    public supplierService: SupplierService,
    private route: ActivatedRoute,
    private _dropdownService: DropdownService,
    private _flashMessage: FlashMessageService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    public modal: ModalService,
  ) { }

  ngAfterViewInit(): void {
    this._supplierSearchSetup();
  }

  ngOnInit() {
    this.supplierService.nameIsInvalid = false;
    if (!this.currentUserService.user) {
      this.router.navigate(['../../users'], { relativeTo: this.route });
      return false;
    }

    this.sub = this.route.queryParams.subscribe(params => {
      this.redirectUrl = params['urlPath'];
      if (params['request']) {
        this.supplierService.resetSupplierUser();
        this.supplierService.newSupplierUser.name = params['name'];
        this.supplierService.newSupplierUser.email = params['email'];
        this.supplierService.newSupplierUser.phone = params['phone'];
        this.supplierService.newSupplierUser.user_from_request = true;
        this.supplierService.newSupplierUser.requestId = _.get(params, 'request', null);
        this.supplierService.newSupplierUser.requestType = "SUPPLIER"
        if (params['mobilePhone'] != 'null') {
          this.supplierService.newSupplierUser.mobile_phone = params['mobilePhone'];
        }
      } else if (params['edit']) {
        this.supplierService.newSupplierUser.name = params['name'];
        this.supplierService.newSupplierUser.email = params['email'];
        this.supplierService.newSupplierUser.phone = params['phone'];
        if (params['mobile'] == "null" || params['mobile'] == 'undefined') {
          this.supplierService.newSupplierUser.mobile_phone = null;
        } else {
          this.supplierService.newSupplierUser.mobile_phone = params['mobile'];
        }
        this.supplierService.newSupplierUser.roleCode = params['userType'];

        if (params['entitlements'].constructor == String) {
          this.matchPrivileges(params['entitlements']);
        } else {
          params['entitlements'].forEach((p) => {
            this.matchPrivileges(p);
          })
        }
      }
      else {
        this.supplierService.resetSupplierUser();
        this.resetPrivileges();
      }
      if (this.currentUserService.user.role.type.toLowerCase() === 'supplier') {
        this.supplierService.newSupplierUser.organization_id = this.currentUserService.user.organizationCode;
      }
      if (params['supplierID']) {
        this.supplierService.newSupplierUser.organization_id = params['supplierID'];
      }
    });
    this.assignRoleValues();

  }

  public assignRoleValues() {
    if (this.currentUserService.user.role.code == "HC_SUPPLIER_ADMIN") {
      this.currentUserRole = 'supplierAdmin';
      this.roleOptions = [this.supplierUserRole, this.supplierAdminRole];
    }
    else if (this.currentUserService.isInternal) {
      this.currentUserRole = 'hubAdmin';
      this.roleOptions = [this.supplierUserRole, this.supplierAdminRole];
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public matchPrivileges(privilege) {
    this.privileges[privilege] = true;
    if (privilege == "HC_SUPPLIER_CREATE_USER" || privilege == "HC_SUPPLIER_DELETE_USER" ||
      privilege == "HC_SUPPLIER_UPDATE_USER" || privilege == "HC_SUPPLIER_VIEW_USER") {
      this.userManagement = true;
    }
  }

  public setupPrivileges() {
    this.resetPrivileges();
    var allowed = [];

    // SUPPLIER ADMIN
    if (this.supplierService.newSupplierUser.roleCode == "HC_SUPPLIER_ADMIN") {
      allowed = [
        'HC_SUPPLIER_PURCHASE_ORDERS'
      ];
      this.userManagement = true;
    }

    // SUPPLIER USER
    else if (this.supplierService.newSupplierUser.roleCode == "HC_SUPPLIER_USER") {
      allowed = [
        'HC_SUPPLIER_PURCHASE_ORDERS'
      ];
      this.userManagement = false;
    }

    this.allowPrivileges(allowed);
  }

  resetPrivileges() { // sets all the user privileges to false/defaults
    for (var key in this.privileges) {
      this.privileges[key] = false;
    }
  }

  allowPrivileges(allowed) { // adds the set privileges for roles
    allowed.forEach(element => {
      this.privileges[element] = true;
    });
    this.toggleSupplierManagementChoices();
  }

  public toggleSupplierManagementChoices() {
    if (this.userManagement == true) {
      this.privileges['HC_SUPPLIER_CREATE_USER'] = true;
      this.privileges['HC_SUPPLIER_DELETE_USER'] = true;
      this.privileges['HC_SUPPLIER_UPDATE_USER'] = true;
      this.privileges['HC_SUPPLIER_VIEW_USER'] = true;
    } else {
      this.privileges['HC_SUPPLIER_CREATE_USER'] = false;
      this.privileges['HC_SUPPLIER_DELETE_USER'] = false;
      this.privileges['HC_SUPPLIER_UPDATE_USER'] = false;
      this.privileges['HC_SUPPLIER_VIEW_USER'] = false;
    }
  }

  onSubmit() {
    let selectedPrivileges = [];

    let myObj = this.privileges;
    Object.keys(myObj).forEach(function (privilege) {
      if (myObj[privilege] == true) {
        selectedPrivileges.push(privilege);
      }
    });

    this.supplierService.newSupplierUser.entitlements = selectedPrivileges;
    this.router.navigate([{ outlets: { sup: 'confirm' } }], {})
  }

  onCancel() {
    this.modal.close();
    if (this.outlet && this.outlet.isActivated) {
      this.outlet.deactivate();
    }
    this.router.navigateByUrl(this.router.url, { queryParams: {} });
  }

  private _searchSubscription: Subscription;
  public supplierDD: any[] = [];
  /**
 * Setup Supplier search
 * Observes the element with id "Supplier"
 * Waits 500 milliseconds before it sends filter request to back end
 */
  private _supplierSearchSetup(): void {
    this._searchSubscription = Observable.fromEvent(document.getElementById('supplierSearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      if (!searchText || !searchText.trim()) {
        this.supplierDD = [];
        this.supplierService.newSupplierUser.supplierSearch = null;
        this.supplierService.newSupplierUser.organization_id = null;
      } else {
        this._dropdownService.getDropdown(searchText, 'SUPPLIER').subscribe((result: any[]) => {
          this.supplierDD = result;
        }, () => {
          this._flashMessage.updateMessage('Failed to load suppliers.')
        });
      }
    });
  };

  public selectSupplier(name: string, supplierId: string) {
    this.supplierService.newSupplierUser.organization_id = supplierId;
    this.supplierService.changeSupplierId(supplierId);
    this.supplierService.newSupplierUser.supplierSearch = `${name} - ${supplierId}`;
    this.supplierDD = [];
  }

  ngOnDestroy(): void {
    if (this._searchSubscription) {
      this._searchSubscription.unsubscribe();
    }
  }
}
